module.exports = __webpack_public_path__ + "img/elantra1.5076c438.jpeg";